import { render, staticRenderFns } from "./SelectPeople.vue?vue&type=template&id=948d231a&scoped=true"
import script from "./SelectPeople.vue?vue&type=script&lang=js"
export * from "./SelectPeople.vue?vue&type=script&lang=js"
import style0 from "./SelectPeople.vue?vue&type=style&index=0&id=948d231a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "948d231a",
  null
  
)

export default component.exports